module.exports = __webpack_public_path__ + "static/media/webinar-paloalto623.7978737f.png";